import { Component, OnInit } from '@angular/core';
import { WizardService } from  './wizard.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'postelf';
  
  constructor(private router: Router, private  wizardService:  WizardService) {
    
  }
  
   ngOnInit() {
   console.log("this.router.url:"+window.location);
    if(window.location.toString().lastIndexOf("/") == window.location.toString().length-1){
      this.wizardService.getCurrentConfig().subscribe( data => {
        if(data["code"]==200&&data["installed"]!="yes")
          this.router.navigate(['/wizard']);
        else
          this.router.navigate(['/login']);
      },err=>{
        console.log("error:"+err);
      });
    }
    
   }
}
